module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b8e9e92550d13ba932f978cb32d48c25.gif";